import gql from "graphql-tag";

export const m_CreatePortalSession = gql`
  mutation CreatePortalSession($input: CreatePortalSessionRequestInput!) {
    CreatePortalSession(input: $input) {
      redirectUrl
    }
  }
`;
